import { render, staticRenderFns } from "./ClickMe.vue?vue&type=template&id=a2c0aa90&scoped=true&"
import script from "./ClickMe.vue?vue&type=script&lang=js&"
export * from "./ClickMe.vue?vue&type=script&lang=js&"
import style0 from "./ClickMe.vue?vue&type=style&index=0&id=a2c0aa90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c0aa90",
  null
  
)

export default component.exports